var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnassignedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.938 13.906H4.061v-2.128c0-.999.408-1.954 1.155-2.67A4.007 4.007 0 0 1 8 8c1.041 0 2.037.39 2.783 1.107a3.688 3.688 0 0 1 1.154 2.671v2.128zM8 7.344a2.62 2.62 0 0 1-2.625-2.625A2.62 2.62 0 0 1 8 2.094a2.62 2.62 0 0 1 2.625 2.625A2.62 2.62 0 0 1 8 7.344z",
    fill: "#ABAEB3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnassignedIcon);
export default __webpack_public_path__ + "static/media/unassignedIcon.d5730541.svg";
export { ForwardRef as ReactComponent };